import { refineClauseWithInnerClause } from "@radarly/models/clause/refiner";
import {
  Dataviz,
  DatavizName,
  getDefaultDataviz,
} from "@radarly/models/dataviz";
import { SearchFragmentPinnedPost } from "@radarly/models/search";
import { isPinnedPostCardDataviz } from "../dataviz";
import { Card, PinnedPostCard } from "../model";
import { CardFactory, CardFragmentsFactory } from "./base";
import { ICardFactory } from "./model";

export class PinnedPostCardFragmentsFactory extends CardFragmentsFactory {
  static create(postId?: string) {
    const factory = new PinnedPostCardFragmentsFactory();
    return factory.getFragment(postId);
  }
  private getFragment(postId: string): [SearchFragmentPinnedPost] {
    const clause = { and: [] };

    return [
      {
        request: {
          query:
            postId && postId !== ""
              ? refineClauseWithInnerClause(clause, {
                  query: `uid:"${postId}"`,
                })
              : clause,
          pagination: { limit: 1 },
        },
      },
    ];
  }
}

export class PinnedPostCardFactory
  implements ICardFactory<PinnedPostCard, Record<string, unknown>>
{
  public static getInstance() {
    return new PinnedPostCardFactory();
  }
  public fromCard(
    workspaceId: number,
    projectFocuses: number[],
    card: Card,
    input?: {
      postId?: string;
      dataviz?: Dataviz;
    }
  ) {
    return CardFactory.getInstance<PinnedPostCard>().createCard(
      workspaceId,
      projectFocuses,
      "pinned-post",
      card.title,
      PinnedPostCardFragmentsFactory.create(input.postId),
      this.createDataviz(input?.dataviz || card.dataviz)
    );
  }
  public fromInput(
    workspaceId: number,
    projectFocuses: number[],
    title: string,
    input?: {
      postId?: string;
      dataviz?: Dataviz["name"];
      fullDataviz?: Dataviz;
    }
  ) {
    return CardFactory.getInstance<PinnedPostCard>().createCard(
      workspaceId,
      projectFocuses,
      "pinned-post",
      title,
      PinnedPostCardFragmentsFactory.create(input?.postId),
      this.createDataviz(
        input?.fullDataviz ??
          getDefaultDataviz(input?.dataviz || DatavizName.PinnedPost)
      )
    );
  }
  public createDataviz(dataviz: Dataviz) {
    if (isPinnedPostCardDataviz(dataviz)) {
      return dataviz;
    } else {
      return getDefaultDataviz(
        DatavizName.PinnedPost
      ) as PinnedPostCard["dataviz"];
    }
  }
}
